class UpdateCartItems {
  mockupUrl = 'https://api.mobilfox.com/imager/production/render/mockup.png';
  customImagePrefix = 'custom_image';
  constructor() {
    this.initPageChangeAction();
  }

  initPageChangeAction() {
    const observer = new MutationObserver(async (mutations) => {
      for(let mutation of mutations) {
        for(let node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.matches('div[class*="drawer__content"]')) {
            await this.updateCartItems(node);
          }
        }
      }
    });

    const config = {subtree: true, childList: true};
    observer.observe(document, config);
  }

  async updateCartItems(container) {
    const lineItems = container?.querySelectorAll('.line-item__content-wrapper');
    const cart = await this.getCartObject();

    if (lineItems) {
      let index = 0;
      for (let lineItem of lineItems) {
        const image = lineItem?.querySelector('.line-item__image-wrapper img');

        const cartItem = cart?.items[index];
        if (cartItem?.properties["SKU"]) {
          let options = this.getCaseOptions(cartItem?.properties["SKU"]);

          if (options.customImageId && image && !image.src.includes(options.customImageId)) {
            const url = this.getMockupUrl(options);
            this.updateImageWithErrorHandler(image, url);
            image.style.maxWidth = "75%";
            image.style.marginLeft = "auto";
            image.style.marginRight = "auto";
          }
        }

        index += 1;
      }
    }
  }

  getCaseOptions(propertiesSku) {
    const options = {};
    const cartItemSplit = propertiesSku?.split('#custom_image#');
    const customImageId = cartItemSplit[1] || '';
    const productId = cartItemSplit[0] || '';
    options.graphicSource = this.customImagePrefix;
    options.customImageId = customImageId;
    options.productId = productId;

    return options;
  }

  async getCartObject() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      })
      return response.json();
    } catch (error) {
      console.error('Error -> ', error)
    }
    return null;
  }

  getMockupUrl(options) {
    const url = new URL(this.mockupUrl);
    url.searchParams.set('view', 'back');
    url.searchParams.set('productId', options.productId || '');
    url.searchParams.set('graphicSource', 'custom_image');
    url.searchParams.set('imageId', options.customImageId || '');

    return url.toString();
  }

  updateImageWithErrorHandler(image, url) {
    const imgErrorHandler = (event) => {
      console.error(`Error load customized layer and replace it by product image. URL - ${event.target.src}`);
      image.src = event.target.getAttribute('data-default-src');
      image.srcset = event.target.getAttribute('data-default-srcset');
      const styleAtr = event.target.getAttribute('data-default-style');
      image.style = styleAtr ? styleAtr : "";
      image.onerror = null;
    }
    image.removeEventListener('error', imgErrorHandler);
    image.addEventListener('error', imgErrorHandler);

    image.setAttribute('data-default-src', image.src);
    image.setAttribute('data-default-srcset', image.srcset);
    image.setAttribute('data-default-style', image.getAttribute('style'));

    image.src = url;
    image.srcset = "";
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new UpdateCartItems();
});
